import React from 'react';
import { Link, Typography } from '@esgian/esgianui';

//-------------------------- OPERATOR PROFILE --------------------------
export const OPERATOR_PROFILE_FLEET_CII_RATING_TEXT = `Number of vessels of the fleet with each CII rating based on estimated CO₂ emission. 
Completed years have ratings based on the emission for the corresponding year. 
Rating for the current year and upcoming years are ratings based on the rating criteria for the 
corresponding year assuming the fleet operation is same as the latest completed year.`;

//-------------------------- DRAUGHT ON ARRIVAL/DEPARTURE --------------------------
export const DRAUGHT_ON_ARRIVAL_DEPARTURE_TEXT = `Draught Reported / Max Draught (%)`;
export const DRAUGHT_ON_ARRIVAL_DEPARTURE_POD_TEXT = `Draught Reported / Max Draught (%) at POD`;
export const DEPARTURE_DATE_TEXT = `Please note that there is a delay of up to 24 hours for the latest departure information`;
export const ESTIMATED_CARGO_WEIGHT_TEXT = `The total cargo weight onboard a vessel is estimated using a cargo weight estimation model developed by Esgian based on draught of the vessel. The model was developed based on ratio of cargo weight and ballast water weight data from actual voyages. The model has proven to be significantly better compared to using load factors.`;

//-------------------------- VESSEL PROFILE --------------------------
export const INSUFFICIENT_DATA_FOR_EMISSIONS = `Insufficient data to compute emissions`;

//-------------------------- REGION PROFILE --------------------------

//-------------------------- COUNTRY PROFILE --------------------------

export const PORT_CALLS_TEXT = `No. of port calls in`;

export const PORT_TIME_TEXT = `Average port time in`;

export const PORT_WAITING_TIME_TEXT = `Average port waiting time in`;

//-------------------------- PORT PROFILE --------------------------
export const INSUFFICIENT_DATA_FOR_PORT_STATISTICS = `Insufficient data to compute port statistics`;

//-------------------------- OWNER PROFILE --------------------------

//-------------------------- GENERAL --------------------------
export const LAST_PORT_CALLS_RECORDS_TEXT = `Displaying only the most recent 250 port calls. The complete list is accessible in the download button.`;
export const LESS_THAN_250_RECORDS = `Total number of port calls:`;
export const GLOBAL_AVERAGE_PORT_TIME_TEXT = `The port time is defined as the time when a vessel is within a terminal geofence and whose speed is less than 1 kn. In the case of vessel calling multiple terminal geofences during the port event, the port time is taken as the time from entering the first geofence, to leaving the final geofence, where speed is less than 1 kn.`;

export const SERVICE_LEVEL_TEXT = `Service Level counts the services completed by each operator between the selected region to region / country to country / port to port (or any combination of the three) by carrier and calculates performance on frequency and transit time. The module will look for voyages completed within the set period of the search. You are also able to search port pairs within a country or region, e.g. Europe to Bremerhaven. Moreover, you can search a region/country to a region/country, e.g. Japan to Japan`;
export const PORT_ACTIVITY_TITLE = `Obtain information regarding the operators that made port calls at a specified port/country/region, including their frequency and consistency.`;

export const OPERATOR_PERFORMANCE_TITLE = `Analyze the number of sailings, service frequency, schedule reliability, and transit times of any operator between specific ports, countries, or regions, and benchmark the performance against the rest of the segment.`;

export const OPERATOR_FLEET_SIZE_TITLE = `The present fleet size of an operator tracked by Esgian`;
export const OPERATOR_AVG_AGE_TITLE = `Average age of the present fleet of an operator tracked by Esgian`;
export const OPERATOR_AVG_CAP_RORO_TITLE = `Average capacity in Car Equivalent Unit corresponding to the present fleet of an operator tracked by Esgian`;
export const OPERATOR_AVG_CAP_MPP_TITLE = `Average capacity in Deadweight corresponding to the present fleet of an operator tracked by Esgian`;
export const OPERATOR_TOTAL_CAP_RORO_TITLE = `Total capacity in Car Equivalent Unit corresponding to the present fleet of an operator tracked by Esgian`;
export const OPERATOR_TOTAL_CAP_MPP_TITLE = `Total capacity in Deadweight corresponding to the present fleet of an operator tracked by Esgian`;
export const OPERATOR_FLEET_DEV_RORO_TITLE = `Gain insights into the number and capacity of vessels operated by selected operators over a given period. Esgian updates vessel operator data monthly using information from our partner, Hesnes Shipping, along with spontaneous updates based on operator input. Please note that fleet development statistics include only vessels and operators covered by Esgian Shipping.`;
export const OPERATOR_FLEET_DEV_MPP_TITLE = `Gain insights into the number and capacity of vessels operated by selected operators over a given period. Esgian updates vessel operator data monthly using information from our partner, Toepfer Transport GmbH, along with spontaneous updates based on operator input. Please note that fleet development statistics include only vessels and operators covered by Esgian Shipping.`;
export const OPERATOR_ACTIVITY_SPEED_RORO_TITLE = `Average transit speed (speed > 3 kts) of the fleet compared to the average speed of the entire RORO segment tracked by Esgian`;
export const OPERATOR_ACTIVITY_SPEED_MPP_TITLE = `Average transit speed (speed > 3 kts) of the fleet compared to the average speed of the entire MPP segment tracked by Esgian`;
export const OPERATOR_ACTIVITY_ARRIVAL_TITLE = `Time of arrival at first berth.`;
export const OPERATOR_ACTIVITY_DEPARTURE_TITLE = `Time of departure from final berth. An empty departure time may indicate the vessel is still at berth or the status is yet to be updated.`;
export const OPERATOR_ACTIVITY_TIME_TITLE = `Total time spent between arrival at first berth and departure from last berth in a port. If there is a period more than 24 hours between multiple berthing in a port, it will be considered as separate port calls.`;
export const OPERATOR_COMMERCIAL_FOOTPRINT_TITLE = `Get insights on ports called by an operator’s fleet and identify new ports called in the selected quarter compared to the previous quarter.`;

export const OWNER_FLEET_SIZE_TITLE = `The present fleet size of an owner tracked by Esgian`;
export const OWNER_AVG_AGE_TITLE = `Average age of the present fleet of an owner tracked by Esgian`;
export const OWNER_AVG_CAP_TITLE = `Average capacity in Car Equivalent Unit corresponding to the present fleet of an owner tracked by Esgian`;
export const OWNER_TOTAL_CAP_TITLE = `Total capacity in Car Equivalent Unit corresponding to the present fleet of an owner tracked by Esgian`;

export const VESSEL_SPEED_HISTOGRAM_TITLE = `The percentage of time the vessel spent in each speed range over the past 12 months, compared to the corresponding data from the most recent completed year.`;
export const VESSEL_ACTIVITY_SPEED_RORO_TITLE = `Average transit speed (speed > 3 kts) of the vessel compared to the average speed of the entire RORO segment tracked by Esgian`;
export const VESSEL_ACTIVITY_SPEED_MPP_TITLE = `Average transit speed (speed > 3 kts) of the vessel compared to the average speed of the entire MPP segment tracked by Esgian`;

export const PORT_UPCOMING_TITLE = `Upcoming port calls based on next destination and ETA reported by the vessels.`;

export const REGION_ACTIVITY_TITLE = `Visualize vessels and their voyage path in a region on any selected date.`;
export const REGION_HISTORICAL_TITLE = `Get insights into operators and their share of activity in a region for any selected period.`;

export const COMPLETED_VOYAGE_TITLE = `Retrace any historical voyages and gain detailed insights into GHG emission estimates for Scope 3 reporting, EU ETS calculations, port visits, waiting times, vessel speed, activities, fuel consumption and other key operational metrics.`;
export const COMPLETED_VOYAGE_PERIOD_TITLE = `Choose an approximate timeframe for the voyage's start and end dates.`;
export const COMPLETED_VOYAGE_LINK_TITLE = `Click on ‘View’ to view detailed insights of the voyage`;
export const COMPLETED_VOYAGE_TRANSIT_TIME_TITLE = `Set a maximum limit on the duration of a voyage to filter out several rotations. `;
export const ONGOING_VOYAGE_TITLE = `Track any vessels from a start date and view their activity. Save voyages to a group to continuously track them and set destinations to stop tracking.`;

export const EMISSION_OPERATORS_EMISSION_TITLE = `Compare operators' CO2 emissions across different metrics based on the vessels they operated within a selected timeframe.`;
export const EMISSION_VESSELS_EMISSION_TITLE = `Compare vessels' CO2 emissions across different metrics based on their operation within a selected timeframe.`;

//-------------------------- CATEGORY FILTERS --------------------------

export const COM_CAT_TYPE_ALL_TEXT = (
  <React.Fragment>
    <Typography variant={'caption'}>
      This filter displays all vessels covered in the MPP Segment in Esgian Shipping.
    </Typography>
  </React.Fragment>
);

export const COM_CAT_TYPE_DEEP_SEA_CORE_TEXT = (
  <React.Fragment>
    <Typography variant={'caption'}>
      This is the primary MPP segment with vessels having at least 100 mt of combined lifting
      capacity, at least 2.500 dwt cargo carrying capacity and max 30 years of age.
    </Typography>
    <br />
    <Typography variant={'caption'}>
      The vessels falling into this category are regularly mapped to a commercial operator by
      Toepfer Transport GmbH.
    </Typography>
  </React.Fragment>
);

export const COM_CAT_TYPE_DEEP_SEA_EXT_TEXT = (
  <React.Fragment>
    <Typography variant={'caption'}>
      This segment includes all vessels/operators in the “Deep-sea Core” category, but also vessels
      by operators in the Core category not meeting all selection criteria enabling a more complete
      view at the operator level.
    </Typography>
    <br />
    <Typography variant={'caption'}>
      In addition, key players such as SagaWelco and G2 Ocean can be found in this segment. The
      vessels falling into this category are regularly mapped to a commercial operator by Toepfer
      Transport GmbH.
    </Typography>
  </React.Fragment>
);
export const COM_CAT_TYPE_SHORT_SEA_EUR_TEXT = (
  <React.Fragment>
    <Typography variant={'caption'}>
      Depending on definition, the EU Short-sea MPP fleet counts some 2.000 - 3.000 ships.
    </Typography>
    <br />
    <Typography variant={'caption'}>
      The Esgian suite seeks to cover the main 20 + operators and their fleet, but is continuously
      expanding.
    </Typography>
    <br />
    <Typography variant={'caption'}>
      The vessels falling into this category are regularly mapped to a commercial operator by
      Toepfer Transport GmbH.
    </Typography>
  </React.Fragment>
);

export const COM_CAT_TYPE_OTHER_TEXT = (
  <React.Fragment>
    <Typography variant={'caption'}>
      This segment covers the niche market of Widedeck carriers. These unique vessels have some
      typical features, such as a front deckhouse, a large, open deck space, the absence of a cargo
      hold, and strong hull and deck reinforcements. There are specific constraints for operation
      when loaded, such as acceleration limits, maximum wave height and weather conditions. These
      vessels are usually employed in carrying renewable energy components such as wind turbine
      blades and towers.
    </Typography>
    <br />
    <Typography variant={'caption'}>
      The vessels falling into this category are NOT mapped by Toepfer and done on a “best effort
      basis”.
    </Typography>
  </React.Fragment>
);

export const OPR_TYPE_BOTH_TEXT = (
  <React.Fragment>
    <Typography variant={'caption'}>
      This filter shows all RoRo vessels and operators tracked by Esgian and as such combines both
      Deep-sea and Short-sea operators.
    </Typography>
    <br />
    <Typography variant={'caption'}>
      From the outset, our threshold is vessels with the CEU capacity {'>'} 1.800, but for Short-sea
      this is lower to capture the entire fleet of the operators covered in our software.
    </Typography>
  </React.Fragment>
);

export const OPR_TYPE_SHORT_SEA_TEXT = (
  <React.Fragment>
    <Typography variant={'caption'}>
      This filter displays operators and their fleet who is primarily engaged in intracontinental
      trading.
    </Typography>
    <br />
    <Typography variant={'caption'}>
      Like for Deep-Sea, if the majority of the activity is Short-Sea, the operator’s activity will
      count towards this segment. One example here is Neptune Lines.
    </Typography>
  </React.Fragment>
);
export const OPR_TYPE_DEEP_SEA_TEXT = (
  <React.Fragment>
    <Typography variant={'caption'}>
      This filter displays operators and their fleet which is primarily engaged in intercontinental
      trading.
    </Typography>
    <br />
    <Typography variant={'caption'}>
      If a carrier has most of its activity between regions, their activity will count towards the
      Deep-sea segment. One example here is Toyofuji.
    </Typography>
  </React.Fragment>
);

//-------------------------- VOYAGE ANALYTICS --------------------------

export const ESTIMATED_AVG_EU_ETS_COST_TEXT = (
  <React.Fragment>
    <Typography variant={'body2'}>
      Estimated EU ETS cost based on Avg. cargo weight of the entire voyage
    </Typography>
  </React.Fragment>
);

export const EU_ALLOWANCE_FOR_MY_CARGO = (
  <React.Fragment>
    <Typography variant={'body2'}>
      EU Allowances (EUAs) are a type of carbon allowance that allows companies covered by the EU
      ETS to emit a certain amount of CO₂e.
    </Typography>
  </React.Fragment>
);

export const OVERALL_VOYAGE_PHASE_IN_FACTOR = (
  <React.Fragment>
    <Typography variant={'body2'}>
      To ensure a smooth transition, shipping companies only have to surrender allowances for a
      portion of their emissions during an initial phase-in period:
    </Typography>
    <Typography variant={'body2'}>- 2025: for 40% of their emissions reported in 2024</Typography>
    <Typography variant={'body2'}>- 2026: for 70% of their emissions reported in 2025</Typography>
    <Typography variant={'body2'}>- 2027 onwards: for 100% of their reported emissions</Typography>
  </React.Fragment>
);

export const OVERALL_VOYAGE_EU_ALLOWANCES = (
  <React.Fragment>
    <Typography variant={'body2'}>EU ETS covers</Typography>
    <Typography variant={'body2'}>
      -50% of emissions from voyages starting or ending outside of the EU (allowing the third
      country to decide on appropriate action for the remaining share of emissions);
    </Typography>
    <Typography variant={'body2'}>
      -100% of emissions that occur between two EU ports and when ships are within EU ports.
    </Typography>
  </React.Fragment>
);
export const ETS_COST_PER_TONNE = (
  <React.Fragment>
    <Typography variant={'body2'} style={{ whiteSpace: 'wrap' }}>
      EU-ETS Allowance price. Esgian assumes the price as the price corresponding to the day when
      the voyage ended. User is able to edit this value and get recalculated results.
    </Typography>
    <Typography variant={'body2'} style={{ whiteSpace: 'nowrap' }}>
      The values are referred from
      <Link href="https://www.ice.com/products/197/EUA-Futures/data?marketId=7075802&span=1">
        here
      </Link>
    </Typography>
  </React.Fragment>
);

//-------------------------- OPERATORS OVERVIEW --------------------------
export const IN_ASSOCIATION_WITH_HESNES_SHIPPING_AS_TOOLTIP = (
  <React.Fragment>
    <Typography variant={'caption'}>
      All vessels with a CEU capacity of 1,800 and above are dynamically assigned to a commercial
      operator by Hesnes Shipping. Smaller vessels are not covered by Hesnes and are updated by
      Esgian less frequently based on operator feedback or market updates.
    </Typography>
  </React.Fragment>
);
